<template>
  <Teleport to="body">
  <div v-if="isOpen" class="modal-backdrop" :style="{ zIndex }" @click.self="close">
    <div class="modal-container shadow-lg" role="dialog" aria-modal="true" style="max-width: 480px;">
      <header class="modal-header">
        <h5 class="modal-title d-flex align-items-center">
          <i class="bi bi-info-circle-fill me-2 text-primary"></i>
          Sobre o Sistema
        </h5>
        <button type="button" class="btn-close btn-close-white" @click="close" aria-label="Fechar"></button>
      </header>

      <div class="modal-body bg-body px-4 py-4">
        <div class="text-center mb-4">
          <i class="bi bi-buildings fs-1 text-secondary opacity-50"></i>
          <h4 class="mt-2 mb-1 fw-bold">CTech - ERP Comex</h4>
          <p class="text-muted small mb-0">Sistema de Gestão e Comércio Exterior</p>
        </div>

        <table class="table table-sm table-borderless mb-0">
          <tbody>
            <tr>
              <td class="text-muted pe-3" style="width: 120px;">Release</td>
              <td class="fw-semibold">{{ releaseName || '—' }}</td>
            </tr>
            <tr>
              <td class="text-muted pe-3">Build</td>
              <td class="fw-semibold">{{ buildTime || '—' }}</td>
            </tr>
            <tr>
              <td class="text-muted pe-3">Ambiente</td>
              <td class="fw-semibold">{{ environmentLabel }}</td>
            </tr>
            <tr>
              <td class="text-muted pe-3">Framework</td>
              <td class="fw-semibold">Vue.js 3 + .NET 8</td>
            </tr>
            <tr>
              <td class="text-muted pe-3">Banco</td>
              <td class="fw-semibold">PostgreSQL</td>
            </tr>
          </tbody>
        </table>
      </div>

      <footer class="modal-footer justify-content-center bg-body-tertiary">
        <small class="text-muted">&copy; {{ currentYear }} Camuri Tech. Todos os direitos reservados.</small>
      </footer>
    </div>
  </div>
  </Teleport>
</template>

<script>
import { ref, onUnmounted } from 'vue'
import { reservarZIndex, liberarZIndex, BASE_ZINDEX } from '@/composables/useZIndex'

function detectEnvironment () {
  const env = (process.env.VUE_APP_ENV || '').toLowerCase()
  if (env) {
    const labels = { development: 'Desenvolvimento', homologation: 'Homologação', production: 'Produção' }
    return labels[env] || 'Produção'
  }
  const host = window.location.hostname
  if (host === 'localhost' || host === '127.0.0.1') return 'Desenvolvimento'
  if (host.includes('homolog') || host.includes('staging') || host.includes('test')) return 'Homologação'
  return 'Produção'
}

export default {
  name: 'AboutModal',
  props: {
    releaseName: { type: String, default: '' },
    buildTime: { type: String, default: '' }
  },
  setup () {
    const isOpen = ref(false)
    // --- Empilhamento (z-index) via registry central ---
    const zIndex = ref(BASE_ZINDEX)
    const tokenZIndex = ref(null)

    const show = () => {
      const { token, zIndex: z } = reservarZIndex()
      tokenZIndex.value = token
      zIndex.value = z
      isOpen.value = true
    }
    const close = () => {
      isOpen.value = false
      liberarZIndex(tokenZIndex.value)
      tokenZIndex.value = null
    }

    // Segurança: libera o z-index caso o componente seja desmontado ainda aberto
    onUnmounted(() => {
      liberarZIndex(tokenZIndex.value)
      tokenZIndex.value = null
    })

    const environmentLabel = detectEnvironment()
    const currentYear = new Date().getFullYear()

    return { isOpen, zIndex, show, close, environmentLabel, currentYear }
  }
}
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-container {
  background-color: var(--bs-body-bg);
  border: 1px solid var(--bs-border-color-translucent);
  border-radius: 0.75rem;
  overflow: hidden;
  width: 90%;
  max-width: 480px;
}
.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  background-color: var(--bs-tertiary-bg);
  border-bottom: 1px solid var(--bs-border-color-translucent);
}
.modal-body {
  padding: 1.5rem;
}
.modal-footer {
  padding: 0.75rem 1.5rem;
  border-top: 1px solid var(--bs-border-color-translucent);
}
.table-borderless td {
  padding: 0.35rem 0;
}
</style>
